<template>
  <div id="app">
    <el-container>
      <el-header>
        <el-main><h2>Не удалось завершить оплату</h2></el-main>
      </el-header>
    </el-container>
    <el-row type="flex" justify="center" id="mainForm">
      <el-col :xs="22" :sm="16" :md="14" :lg="12" :xl="8">
        <el-card shadow="always" class="text-center one-control">
          <el-link type="primary" @click.prevent="newPayment()">Попробовать ещё раз</el-link>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    newPayment() {
      this.$router.push("/payment");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/finishError.vue